/* eslint-disable max-len */
export default {
    header: {
        title: 'Wypełnij poniższy formularz',
        subtitle: 'Nasz zespół skontaktuje się z Tobą niezwłocznie, aby omówić kolejne kroki.',
        main: 'Wybierz usługę która cię interesuje'
    },
    list: {
        improve_title: 'Popraw bezpieczeństwo i/lub zgodność aplikacji z przepisami RODO',
        decrease_title: 'Zmniejsz ryzyko cyberataku w Twojej organizacji (Zarządzanie danymi)'
    },
    improve: [{
        title: 'Chcę sprawdzić bezpieczeństwo moich aplikacji pod kątem:',
        slug: 'improve-one',
        number: '1/4',
        option: [{
            text: 'Web',
            slug: 'web',
            icon: 'improve11'
        }, {
            text: 'Mobile',
            slug: 'mobile',
            icon: 'improve12'
        }, {
            text: 'Serwer',
            slug: 'server',
            icon: 'improve13'
        }]
    }, {
        title: 'Chcę, aby zostało sprawdzone bezpieczeństwo:',
        slug: 'improve-two',
        number: '2/4',
        option: [{
            text: 'istniejącej aplikacji',
            slug: 'running',
            icon: 'improve21'
        }, {
            text: 'kodu źródłowego aplikacji',
            slug: 'application',
            icon: 'improve22'
        }, {
            text: 'konfiguracji serwera produkcyjnego',
            slug: 'production',
            icon: 'improve23'
        }]
    }, {
        title: 'Chcę mieć pewność, że aplikacja jest zgodna z RODO z perspektywy:',
        slug: 'improve-three',
        number: '3/4',
        option: [{
            text: 'prawnej (identyfikacja danych osobowych, warunki korzystania z usługi)',
            slug: 'legal',
            icon: 'improve31'
        }, {
            text: 'architektury systemu (przystosowanie do przepisów RODO)',
            slug: 'system',
            icon: 'improve32pl'
        }, {
            text: 'cyberbezpieczeństwa (bezpieczeństwo danych osobowych)',
            slug: 'cybersecurity',
            icon: 'improve33'
        }]
    }, {
        title: 'Po weryfikacji pragnę uzyskać:',
        slug: 'improve-four',
        number: '4/4',
        option: [{
            text: 'wsparcie w fazie nanoszenia poprawek',
            slug: 'support',
            icon: 'common1'
        }, {
            text: 'ponowne sprawdzenie po zastosowaniu poprawek',
            slug: 're-check',
            icon: 'common2'
        }, {
            text: 'ciągły monitoring działającej aplikacji i jej kodu źródłowego',
            slug: 'monitor',
            icon: 'improve43'
        }]
    }],
    decrease: [{
        title: 'Zasoby cyfrowe w mojej organizacji wymagają:',
        slug: 'decrease-one',
        number: '1/3',
        option: [{
            text: 'nagrania i utrwalenia',
            slug: 'recording',
            icon: 'decrease11'
        }, {
            text: 'obliczenia ryzyka',
            slug: 'calculation',
            icon: 'decrease12'
        }, {
            text: 'polityki zarządzania ryzykiem/polityki bezpieczeństwa',
            slug: 'management',
            icon: 'decrease13'
        }]
    }, {
        title: 'Aby ochronić:',
        slug: 'decrease-two',
        number: '2/3',
        option: [{
            text: 'dane osobowe',
            slug: 'personal',
            icon: 'decrease21'
        }, {
            text: 'know how, przepisy i tajemnice handlowe',
            slug: 'know-how',
            icon: 'decrease22'
        }, {
            text: 'listy płac i wynagrodzeń',
            slug: 'payroll',
            icon: 'decrease23'
        }]
    }, {
        title: 'Po weryfikacji pragnę uzyskać:',
        slug: 'decrease-three',
        number: '3/3',
        option: [{
            text: 'wsparcie w fazie nanoszenia poprawek',
            slug: 'correction',
            icon: 'common1'
        }, {
            text: 'ponowne sprawdzenie po zastosowaniu poprawek',
            slug: 'applying',
            icon: 'common2'
        }, {
            text: 'przygotowany raport weryfikacyjny',
            slug: 'verification',
            icon: 'decrease33'
        }]
    }],
    form: {
        name: 'Imię i nazwisko',
        mail: 'Mail',
        phone: 'Telefon',
        message: 'Wiadomość',
        send: 'Wyślij',
        refresh: 'Odśwież'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/estimation.js